(function () {
  function initProductBox(sectionEl) {
    var form = sectionEl.querySelector("[data-product-box-form]");
    if (!form) return;

    var flavoursRoot = sectionEl.querySelector("[data-box-flavours]");
    var submitBtn = form.querySelector("[data-product-box-submit]");
    var errorEl = sectionEl.querySelector("[data-product-box-error]");
    var limit = parseInt(flavoursRoot && flavoursRoot.dataset.limit, 10) || 4;

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message || "";
      errorEl.hidden = !message;
    }

    function updateSubmit() {
      if (!submitBtn || !flavoursRoot) return;
      var isComplete = window.HappyJoBoxFlavours.getTotal(flavoursRoot) === limit;
      submitBtn.disabled = !isComplete;
      submitBtn.setAttribute("aria-disabled", isComplete ? "false" : "true");
    }

    if (flavoursRoot) {
      flavoursRoot.addEventListener("box:change", updateSubmit);
      updateSubmit();
    }

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      showError("");

      if (!flavoursRoot || window.HappyJoBoxFlavours.getTotal(flavoursRoot) !== limit) {
        return;
      }

      var variantId = form.querySelector('[name="id"]').value;
      var quantityInput = form.querySelector('[name="quantity"]');
      var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

      var properties = window.HappyJoBoxCart.buildFlavorProperties(
        window.HappyJoBoxCart.getFlavorInputs(flavoursRoot, ".box__qty-input"),
        function (input) {
          return input.value;
        },
        function (input) {
          return input.getAttribute("data-flavour-name");
        }
      );

      submitBtn.disabled = true;
      submitBtn.classList.add("product-box__submit--loading");

      window.HappyJoBoxCart
        .addPackToCart({
          variantId: variantId,
          quantity: quantity,
          properties: properties,
        })
        .then(function () {
          if (window.HappyJoCartDrawer && window.HappyJoCartDrawer.isEnabled()) {
            return window.HappyJoCartDrawer.openAfterAdd();
          }
          window.location.href = "/cart";
        })
        .catch(function (err) {
          showError(err.message);
        })
        .finally(function () {
          submitBtn.classList.remove("product-box__submit--loading");
          updateSubmit();
        });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-product-box-section]").forEach(initProductBox);
  });
})();
